export const LINK_CG_TERMINAL_FORM  = {
  addCGTLink: document.querySelector('#aafp_terminal-cardgoroup-form') as HTMLFormElement,
  updateCGTLink: document.querySelector('#aafp_update-tcg-form') as HTMLFormElement,
  partnerName: document.querySelector('#aafp_tcg-partner-name') as HTMLInputElement,
  terminalName: document.querySelector('#aafp_tcg-terminal-name') as HTMLInputElement,
  searchInput: document.querySelector('#aafp_cardgroup-input') as HTMLInputElement,
  searchButton: document.querySelector('#aafp_cardgroup-find') as HTMLElement,
  searchResults: document.querySelector('.aafp_cg-search-result') as HTMLElement,
  searchSelected: document.querySelector('.aafp_cg-selected') as HTMLElement,
  taxSelected: document.querySelector('.aafp_tax-selected') as HTMLElement,
  submitButton: document.querySelector('#aafp_cgt-submit') as HTMLButtonElement
}

export const LINK_CG_TERM_TAX_FORM = {
  addCGTaxLink: document.querySelector('#aafp_tax-term-cg-form') as HTMLFormElement,
  cgTTcustomer: document.querySelector('#aafp_tax-term-cg-customer-name') as HTMLInputElement,
  cgTTcardgroup: document.querySelector('#aafp_tax-term-cg-cardgroup-name') as HTMLInputElement,
  cgTTterminal: document.querySelector('#aafp_tax-term-cg-terminal-name') as HTMLInputElement,
  cgTTsearchInput: document.querySelector('#aafp_tax-input') as HTMLInputElement,
  cgTTsearchButton: document.querySelector('#aafp_tax-find') as HTMLElement,
  cgTTsearchResults: document.querySelector('.aafp_tax-search-result') as HTMLElement,
  cgTTsearchSelected: document.querySelector('.aafp_tax-selected') as HTMLElement,
  cgTTsubmitButton: document.querySelector('#aafp_tax-cgt-submit') as HTMLButtonElement
}